export const GUI_EMAIL = "GUI_EMAIL";
export const GUI_EMAIL_SUCCESS = "GUI_EMAIL_SUCCESS";
export const GUI_EMAIL_FAILURE = "GUI_EMAIL_FAILURE";

export const SHOW_GUI_EMAIL = "SHOW_GUI_EMAIL";
